// extracted by mini-css-extract-plugin
module.exports = {"section":"Menu_section__26KKd","top":"Menu_top__1exbW","link":"Menu_link__2FepG","mobileWrapper":"Menu_mobileWrapper__3wyUr"};